import { IdlAccounts, IdlTypes, Program } from "@coral-xyz/anchor";
import type { Referral as ReferralTypes } from "./idl/referral";
import BN from "bn.js";

export type ReferralProgram = Program<ReferralTypes>;
export type StakingAccount = IdlAccounts<ReferralTypes>["staking"];
export type EscrowAccount = IdlAccounts<ReferralTypes>["escrow"];
export type UnstakeAccount = IdlAccounts<ReferralTypes>["unstake"];
export type StakingConfig = IdlTypes<ReferralTypes>["stakingConfig"];
export type StakingMetrics = IdlTypes<ReferralTypes>["stakingMetrics"];
export type ConfigFields = IdlTypes<ReferralTypes>["configFields"];

export const U64_MAX = new BN("18446744073709551615");
